import styled from 'styled-components';

export const FormOptionsContainer = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 10px;
`;
